import * as React from "react";
import PropTypes from "prop-types";

const TrailDetails = ({ details }) => {
  //console.log(details);
  let detailsArray = [];
  if (details.miles) {
    detailsArray.push(details.miles + " <br/><span>miles</span>");
  }

  if (details.descent) {
    detailsArray.push(details.descent + " <br/><span>descent</span>");
  }
  if (details.elevationGain) {
    detailsArray.push(details.elevationGain + " <br/><span>elev gain</span>");
  }
  if (details.high) {
    detailsArray.push(details.high + " <br/><span>high</span>");
  }
  if (details.low) {
    detailsArray.push(details.low + " <br/><span>low</span>");
  }
  if (details.aveGrade) {
    detailsArray.push(details.aveGrade + " <br/><span>avg grade</span>");
  }
  if (details.maxGrade) {
    detailsArray.push(details.maxGrade + " <br/><span>max grade</span>");
  }

  let content =
    "<div className='columns'><div className='column is-" +
    (12 - details.length) +
    "'></div><div className='column is-1 trail-detail-columns'>" +
    detailsArray.join(
      "</div><div className='column is-1 trail-detail-columns left-border'>"
    ) +
    "</div></div></div>";
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </>
  );
};

TrailDetails.propTypes = {
  details: PropTypes.object,
};

export default TrailDetails;
